(function () {

  /* ── Utilities ── */

  function formatMoney(cents) {
    var fmt = (window.Shopify && window.Shopify.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', String(Math.floor(cents / 100)))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.floor(cents / 100)));
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.setAttribute('data-count', count);
      node.hidden = count === 0;
    });
  }

  async function refreshCartCount() {
    var response = await fetch(window.routes.cart_url + '.js', {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) return null;
    var cart = await response.json();
    updateCartCount(cart.item_count || 0);
    return cart;
  }

  function getCartAddUrl(form) {
    var route = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : form.action;
    return route.endsWith('.js') ? route : route + '.js';
  }

  async function parseCartResponse(response) {
    var text = await response.text();
    if (!text) return {};
    try { return JSON.parse(text); } catch (e) { return { description: text }; }
  }

  async function addFormToCart(form) {
    var response = await fetch(getCartAddUrl(form), {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    });
    var payload = await parseCartResponse(response);

    if (!response.ok || payload.status >= 400) {
      throw new Error(payload.description || payload.message || 'Unable to add item.');
    }

    var cart = await refreshCartCount();
    document.dispatchEvent(new CustomEvent('bio-beast:cart:updated', { detail: { item: payload, cart: cart } }));
    return payload;
  }

  function setStatusMessage(node, text, type) {
    if (!node) return;
    node.textContent = text || '';
    node.classList.toggle('is-error', type === 'error');
    node.classList.toggle('is-success', type === 'success');
  }

  function getSelectedVariantStateNode(form) {
    var variantSelect = form.querySelector('[data-variant-select]');
    if (variantSelect) return variantSelect.options[variantSelect.selectedIndex] || null;
    return form.querySelector('[data-selected-variant-available]');
  }

  function isSelectedVariantAvailable(form) {
    var stateNode = getSelectedVariantStateNode(form);
    if (!stateNode) return true;
    return (stateNode.dataset.available || stateNode.value) === 'true';
  }

  function getVariantInventoryMax(stateNode) {
    if (!stateNode) return null;
    var management = stateNode.dataset.inventoryManagement || '';
    var policy = stateNode.dataset.inventoryPolicy || '';
    var quantity = parseInt(stateNode.dataset.inventoryQuantity || '', 10);
    if (!management || policy === 'continue' || Number.isNaN(quantity) || quantity <= 0) return null;
    return quantity;
  }

  function syncQuantityControl(form) {
    var stateNode = getSelectedVariantStateNode(form);
    var available = isSelectedVariantAvailable(form);
    var max = getVariantInventoryMax(stateNode);
    var input = form.querySelector('[data-quantity-input]');
    var minus = form.querySelector('[data-quantity-minus]');
    var plus = form.querySelector('[data-quantity-plus]');
    if (!input) return;

    input.disabled = !available;
    input.min = '1';

    if (max !== null) { input.max = String(max); } else { input.removeAttribute('max'); }

    var value = parseInt(input.value || '1', 10);
    if (Number.isNaN(value) || value < 1) value = 1;
    if (max !== null && max > 0 && value > max) value = max;
    if (!available || max === 0) value = 1;
    input.value = String(value);

    if (minus) minus.disabled = !available || value <= 1;
    if (plus) plus.disabled = !available || (max !== null && value >= max);
  }

  function syncProductFormState(form, options) {
    var settings = options || {};
    var button = form.querySelector('[data-product-submit]');
    var dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
    var message = form.querySelector('[data-product-form-message]');
    var available = isSelectedVariantAvailable(form);

    if (button) {
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.classList.remove('is-loading');
      if (!available) {
        button.textContent = 'Sold out';
      } else if (!button.classList.contains('is-success')) {
        button.innerHTML = '<svg class="bb-svg-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4ZM3 6h18M16 10a4 4 0 0 1-8 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg> Add to cart';
      }
    }

    if (dynamicCheckout) dynamicCheckout.classList.toggle('is-hidden', !available);

    syncQuantityControl(form);

    if (settings.clearMessage !== false) setStatusMessage(message, '', '');
  }

  /* ── Mobile menu ── */

  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    var panel = menu.querySelector('[data-mobile-menu-panel]');
    var closeButtons = menu.querySelectorAll('[data-mobile-menu-close]');
    var lastActiveElement = null;
    var touchStartX = 0;
    var touchStartY = 0;
    var trackingSwipe = false;

    function setOpen(isOpen) {
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      menu.setAttribute('aria-hidden', String(!isOpen));
      menu.classList.toggle('is-open', isOpen);
      document.body.classList.toggle('bb-menu-open', isOpen);

      if (isOpen) {
        lastActiveElement = document.activeElement;
        window.setTimeout(function () {
          var firstFocus = menu.querySelector('button[data-mobile-menu-close], a, button');
          if (firstFocus) firstFocus.focus();
          else if (panel) panel.focus();
        }, 50);
      } else if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { setOpen(false); }
      if (event.key !== 'Tab' || menu.getAttribute('aria-hidden') === 'true') return;
      var focusable = menu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 990px)').matches) setOpen(false);
    });

    document.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      var touch = event.touches[0];
      var isOpen = menu.classList.contains('is-open');
      var startsAtLeftEdge = touch.clientX <= 28;
      if (!isOpen && !startsAtLeftEdge) { trackingSwipe = false; return; }
      trackingSwipe = true;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });

    document.addEventListener('touchend', function (event) {
      if (!trackingSwipe || !event.changedTouches || event.changedTouches.length !== 1) return;
      var touch = event.changedTouches[0];
      var deltaX = touch.clientX - touchStartX;
      var deltaY = Math.abs(touch.clientY - touchStartY);
      var isOpen = menu.classList.contains('is-open');
      if (!isOpen && deltaX > 72 && deltaY < 64) { setOpen(true); }
      else if (isOpen && deltaX < -72 && deltaY < 64) { setOpen(false); }
      trackingSwipe = false;
    }, { passive: true });
  }

  /* ── Search modal ── */

  function initSearchModal() {
    var modal = document.querySelector('[data-search-modal]');
    var openButton = document.querySelector('[data-search-open]');
    if (!modal || !openButton) return;

    var input = modal.querySelector('[data-search-input]');
    var closeButtons = modal.querySelectorAll('[data-search-close]');

    function setOpen(isOpen) {
      modal.classList.toggle('is-open', isOpen);
      modal.setAttribute('aria-hidden', String(!isOpen));
      openButton.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('bb-search-open', isOpen);
      if (isOpen && input) { window.setTimeout(function () { input.focus(); }, 50); }
    }

    openButton.addEventListener('click', function () { setOpen(true); });
    closeButtons.forEach(function (button) { button.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') setOpen(false); });
  }

  /* ── Quick-add ── */

  function initQuickAdd() {
    document.addEventListener('submit', async function (event) {
      var form = event.target.closest('[data-quick-add]');
      if (!form) return;

      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      var message = form.querySelector('[data-quick-add-message]');
      var originalLabel = button ? button.innerHTML : '';

      if (button) { button.disabled = true; button.classList.add('is-loading'); }
      setStatusMessage(message, '', '');

      try {
        await addFormToCart(form);
        setStatusMessage(message, 'Added', 'success');
      } catch (error) {
        setStatusMessage(message, error.message, 'error');
      } finally {
        if (button) { button.classList.remove('is-loading'); button.disabled = false; button.innerHTML = originalLabel; }
      }
    });
  }

  /* ── Product forms ── */

  function initProductForms() {
    document.addEventListener('submit', async function (event) {
      var form = event.target.closest('.bb-product-form');
      if (!form || !form.closest('.bb-product-page')) return;
      if (event.submitter && event.submitter.closest('.shopify-payment-button')) return;

      event.preventDefault();

      var button = form.querySelector('[data-product-submit]');
      var message = form.querySelector('[data-product-form-message]');

      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
        button.textContent = 'Adding...';
      }
      setStatusMessage(message, '', '');

      try {
        await addFormToCart(form);
        if (button) {
          button.classList.remove('is-loading');
          button.classList.add('is-success');
          button.textContent = 'Added to cart ✓';
        }
        openCartDrawer();
        window.setTimeout(function () {
          syncProductFormState(form, { clearMessage: false });
          if (button) button.classList.remove('is-success');
        }, 2000);
      } catch (error) {
        var rawMsg = (error.message || '').toLowerCase();
        var isOos = rawMsg.includes('sold out') || rawMsg.includes('unavailable') || rawMsg.includes('out of stock');

        if (isOos) {
          // Mark this variant as sold out in the stateNode so the button disables
          var oosSn = form.querySelector('[data-selected-variant-available]');
          if (oosSn) { oosSn.value = 'false'; oosSn.dataset.available = 'false'; }
          setStatusMessage(message, 'This item is currently out of stock.', 'error');
        } else {
          setStatusMessage(message, error.message || 'Unable to add item.', 'error');
        }

        syncProductFormState(form, { clearMessage: false });
      }
    });
  }

  /* ── Option Pickers (variant pill buttons) ── */

  function initOptionPickers(productPage, variants) {
    var pickers = productPage.querySelector('[data-option-pickers]');
    if (!pickers) return;

    var form = pickers.closest('form');
    var idInput = form ? form.querySelector('[data-selected-variant-id]') : null;
    if (!idInput) return;

    var optionGroups = Array.from(pickers.querySelectorAll('[data-option-group]'));
    if (!optionGroups.length) return;

    function variantAvailable(v) {
      if (!v) return false;
      // Use Shopify's pre-computed flag when available ({{ product | json }} includes this)
      if (typeof v.available === 'boolean') return v.available;
      // Fallback: derive from raw inventory fields
      if (!v.inventory_management) return true;
      if (v.inventory_policy === 'continue') return true;
      return (v.inventory_quantity || 0) > 0;
    }

    function findVariantByOptions(options) {
      return variants.find(function (v) {
        return options.every(function (val, i) { return v['option' + (i + 1)] === val; });
      }) || null;
    }

    // Build selectedOptions from the actual selected variant (not from pills)
    // This is critical: Liquid's option.selected_value defaults to the first-listed
    // option value, but selected_variant may be the first *available* variant —
    // these can differ, causing the wrong variant to be submitted on add-to-cart.
    var initialId = idInput.value;
    var initialVariant = variants.find(function (v) { return String(v.id) === initialId; }) || null;
    var selectedOptions = optionGroups.map(function (_, i) {
      return initialVariant ? (initialVariant['option' + (i + 1)] || '') : '';
    });

    // Lenient: a value is "selectable" if ANY available variant carries it,
    // regardless of what other options are currently chosen. This lets users
    // pick a new option and we auto-resolve the rest.
    function isSelectable(optionIndex, value) {
      return variants.some(function (v) {
        return v['option' + (optionIndex + 1)] === value && variantAvailable(v);
      });
    }

    function updatePillUI() {
      optionGroups.forEach(function (group, gi) {
        var label = group.querySelector('[data-option-current]');
        if (label) label.textContent = selectedOptions[gi] || '';
        group.querySelectorAll('.bb-pv-pill').forEach(function (pill) {
          var val = pill.dataset.optionValue;
          var isSel = selectedOptions[gi] === val;
          var canSel = isSelectable(gi, val);
          pill.classList.toggle('is-selected', isSel);
          pill.classList.toggle('is-unavailable', !canSel);
          pill.setAttribute('aria-checked', String(isSel));
        });
      });
    }

    function applyVariant(v) {
      if (!v) return;
      idInput.value = String(v.id);

      var stateNode = form.querySelector('[data-selected-variant-available]');
      var available = variantAvailable(v);
      var comparePrice = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0;
      var discount = comparePrice ? Math.round((comparePrice - v.price) * 100 / comparePrice) : 0;

      if (stateNode) {
        stateNode.dataset.variantId = String(v.id);
        stateNode.value = String(available);
        stateNode.dataset.available = String(available);
        stateNode.dataset.price = formatMoney(v.price);
        stateNode.dataset.compare = comparePrice ? formatMoney(comparePrice) : '';
        stateNode.dataset.discount = String(discount);
        stateNode.dataset.sku = v.sku || '';
        stateNode.dataset.mediaId = (v.featured_media && v.featured_media.id) ? String(v.featured_media.id)
          : (v.featured_image && v.featured_image.id ? String(v.featured_image.id) : '');
        stateNode.dataset.inventoryManagement = v.inventory_management || '';
        stateNode.dataset.inventoryPolicy = v.inventory_policy || '';
        stateNode.dataset.inventoryQuantity = String(v.inventory_quantity || 0);
        stateNode.dataset.optionLabel = v.title || '';
      }

      productPage.dispatchEvent(new CustomEvent('bio-beast:variant-sync'));
    }

    pickers.addEventListener('click', function (event) {
      var pill = event.target.closest('.bb-pv-pill');
      if (!pill || pill.classList.contains('is-unavailable')) return;

      var idx = parseInt(pill.dataset.optionIndex, 10);
      selectedOptions[idx] = pill.dataset.optionValue;

      // Find exact match first
      var v = findVariantByOptions(selectedOptions);

      // If exact combination is unavailable or missing, find the nearest available
      // variant that has the just-chosen value for this option index.
      if (!v || !variantAvailable(v)) {
        v = variants.find(function (candidate) {
          return candidate['option' + (idx + 1)] === selectedOptions[idx] && variantAvailable(candidate);
        }) || null;
        // Sync selectedOptions to the auto-resolved variant so other pills stay consistent
        if (v) {
          optionGroups.forEach(function (_, i) {
            selectedOptions[i] = v['option' + (i + 1)] || selectedOptions[i];
          });
        }
      }

      updatePillUI();
      if (v) applyVariant(v);
    });

    updatePillUI();
  }

  /* ── Product page ── */

  function initProductPage() {
    document.querySelectorAll('.bb-product-page').forEach(function (productPage) {
      var mainMedia = productPage.querySelector('[data-product-main-media]');
      var panels = Array.from(productPage.querySelectorAll('[data-product-media]'));
      var thumbs = Array.from(productPage.querySelectorAll('[data-product-thumb]'));
      var variantSelect = productPage.querySelector('[data-variant-select]');
      var price = productPage.querySelector('[data-product-price]');
      var compare = productPage.querySelector('[data-product-compare]');
      var discount = productPage.querySelector('[data-product-discount]');
      var sku = productPage.querySelector('[data-product-sku]');
      var productMeta = productPage.querySelector('[data-product-meta]');
      var lowStock = productPage.querySelector('[data-product-low-stock]');
      var forms = Array.from(productPage.querySelectorAll('.bb-product-form'));
      var mainForm = forms.find(function (form) { return !form.matches('[data-sticky-product-form]'); });
      var sticky = productPage.querySelector('[data-sticky-atc]');
      var stickyVariantTitle = productPage.querySelector('[data-sticky-variant-title]');
      var stickyPrice = productPage.querySelector('[data-sticky-price]');
      var zoomButton = productPage.querySelector('[data-product-zoom]');
      var lightbox = productPage.querySelector('[data-product-lightbox]');
      var lightboxImage = productPage.querySelector('[data-product-lightbox-image]');
      var lightboxClose = productPage.querySelector('[data-product-lightbox-close]');
      var lowStockThreshold = parseInt(productPage.dataset.lowStockThreshold || '5', 10);
      var productJsonEl = productPage.querySelector('[data-product-json]');
      var variants = [];
      var activeMediaIndex = panels.findIndex(function (panel) { return panel.classList.contains('is-active'); });
      var touchStartX = 0;

      if (activeMediaIndex < 0) activeMediaIndex = 0;

      if (productJsonEl) {
        try {
          var productData = JSON.parse(productJsonEl.textContent || '{}');
          variants = productData.variants || [];
        } catch (e) { variants = []; }
      }

      function getSelectedStateNode() {
        if (variantSelect) return variantSelect.options[variantSelect.selectedIndex] || null;
        return mainForm ? mainForm.querySelector('[data-selected-variant-available]') : null;
      }

      function findVariantById(id) {
        return variants.find(function (v) { return String(v.id) === String(id); }) || null;
      }

      function isVariantPurchasable(variant, stateNode) {
        // Primary: stateNode holds Liquid's server-rendered truth (or JS-updated after pill click)
        if (stateNode) return (stateNode.dataset.available || stateNode.value) === 'true';
        // Fallback: use variant JSON flag
        if (variant && typeof variant.available === 'boolean') return variant.available;
        return true;
      }

      function getVariantMediaId(variant, stateNode) {
        if (variant && variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
        if (variant && variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
        return stateNode ? stateNode.dataset.mediaId || '' : '';
      }

      function getSelectedVariantData() {
        var stateNode = getSelectedStateNode();
        if (!stateNode) return {};

        var idField = mainForm ? mainForm.querySelector('[name="id"]') : null;
        var variantId = variantSelect
          ? stateNode.value
          : (stateNode.dataset.variantId || (idField ? idField.value : ''));
        var variant = findVariantById(variantId);
        var inventoryQuantity = parseInt(stateNode.dataset.inventoryQuantity || '', 10);

        return {
          id: variantId,
          available: isVariantPurchasable(variant, stateNode),
          price: stateNode.dataset.price || (price ? price.textContent : ''),
          compare: stateNode.dataset.compare || '',
          discount: stateNode.dataset.discount || '0',
          sku: variant && variant.sku ? variant.sku : (stateNode.dataset.sku || ''),
          mediaId: getVariantMediaId(variant, stateNode),
          inventoryManagement: stateNode.dataset.inventoryManagement || '',
          inventoryPolicy: stateNode.dataset.inventoryPolicy || '',
          inventoryQuantity: inventoryQuantity,
          optionLabel: variant && variant.title ? variant.title : (stateNode.dataset.optionLabel || '')
        };
      }

      function syncStateDataToForm(form, data) {
        var idField = form.querySelector('[name="id"]');
        var stateNode = form.querySelector('[data-selected-variant-available]');

        if (idField && idField.matches('input') && data.id) idField.value = data.id;
        if (stateNode) {
          stateNode.dataset.variantId = data.id || '';
          stateNode.value = data.available ? 'true' : 'false';
          stateNode.dataset.available = data.available ? 'true' : 'false';
          stateNode.dataset.inventoryManagement = data.inventoryManagement || '';
          stateNode.dataset.inventoryPolicy = data.inventoryPolicy || '';
          stateNode.dataset.inventoryQuantity = Number.isNaN(data.inventoryQuantity) ? '' : String(data.inventoryQuantity);
        }
      }

      function activateMediaByIndex(index) {
        if (!panels.length) return;
        var nextIndex = Math.max(0, Math.min(index, panels.length - 1));
        activeMediaIndex = nextIndex;

        panels.forEach(function (panel, panelIndex) {
          panel.classList.toggle('is-active', panelIndex === nextIndex);
        });

        thumbs.forEach(function (thumb, thumbIndex) {
          var isActive = thumbIndex === nextIndex;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-pressed', String(isActive));
        });

        var activePanel = panels[nextIndex];
        if (zoomButton) {
          zoomButton.hidden = !activePanel || activePanel.dataset.mediaType !== 'image';
        }
      }

      function activateMediaById(mediaId) {
        if (!mediaId) return;
        var index = panels.findIndex(function (panel) { return panel.dataset.mediaId === String(mediaId); });
        if (index >= 0) activateMediaByIndex(index);
      }

      function syncQuantityPeers(sourceInput) {
        if (!sourceInput) return;
        forms.forEach(function (form) {
          var input = form.querySelector('[data-quantity-input]');
          if (input && input !== sourceInput) input.value = sourceInput.value;
          syncQuantityControl(form);
        });
      }

      function syncVariantState() {
        var data = getSelectedVariantData();
        var selectedStateNode = getSelectedStateNode();

        if (selectedStateNode && variantSelect) {
          selectedStateNode.dataset.available = data.available ? 'true' : 'false';
          selectedStateNode.dataset.inventoryManagement = data.inventoryManagement || '';
          selectedStateNode.dataset.inventoryPolicy = data.inventoryPolicy || '';
          selectedStateNode.dataset.inventoryQuantity = Number.isNaN(data.inventoryQuantity) ? '' : String(data.inventoryQuantity);
        }

        if (price && data.price) price.textContent = data.price;
        if (compare) {
          compare.textContent = data.compare || '';
          compare.classList.toggle('is-hidden', !data.compare);
        }
        if (discount) {
          discount.textContent = data.discount && data.discount !== '0' ? 'Save ' + data.discount + '%' : '';
          discount.classList.toggle('is-hidden', !data.discount || data.discount === '0');
        }
        if (sku) {
          sku.textContent = data.sku ? data.sku : '';
        }
        if (productMeta) {
          productMeta.classList.toggle('is-hidden', !data.sku);
        }
        if (lowStock) {
          var showLowStock =
            data.available &&
            data.inventoryManagement &&
            data.inventoryPolicy !== 'continue' &&
            !Number.isNaN(data.inventoryQuantity) &&
            data.inventoryQuantity > 0 &&
            data.inventoryQuantity <= lowStockThreshold;
          lowStock.classList.toggle('is-hidden', !showLowStock);
          if (showLowStock) {
            var qtySpan = lowStock.querySelector('[data-low-stock-qty]');
            if (qtySpan) qtySpan.textContent = data.inventoryQuantity;
          }
        }
        if (stickyVariantTitle) stickyVariantTitle.textContent = data.optionLabel || '';
        if (stickyPrice && data.price) stickyPrice.textContent = data.price;

        forms.forEach(function (form) {
          syncStateDataToForm(form, data);
          syncProductFormState(form);
        });

        if (data.mediaId) activateMediaById(data.mediaId);
      }

      // Thumbnail clicks
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateMediaByIndex(parseInt(thumb.dataset.mediaIndex || '0', 10));
        });
      });

      // Quantity buttons
      forms.forEach(function (form) {
        form.addEventListener('click', function (event) {
          var input = form.querySelector('[data-quantity-input]');
          if (!input) return;
          if (event.target.closest('[data-quantity-minus]')) { input.stepDown(); syncQuantityPeers(input); }
          if (event.target.closest('[data-quantity-plus]')) { input.stepUp(); syncQuantityPeers(input); }
        });

        form.addEventListener('change', function (event) {
          if (event.target.matches('[data-quantity-input]')) syncQuantityPeers(event.target);
        });

        form.addEventListener('input', function (event) {
          if (event.target.matches('[data-quantity-input]')) syncQuantityPeers(event.target);
        });
      });

      // Legacy select variant (if present)
      if (variantSelect) {
        variantSelect.addEventListener('change', syncVariantState);
      }

      // Touch swipe on main media
      if (mainMedia) {
        mainMedia.addEventListener('touchstart', function (event) {
          if (!event.touches || event.touches.length !== 1) return;
          touchStartX = event.touches[0].clientX;
        }, { passive: true });

        mainMedia.addEventListener('touchend', function (event) {
          if (!event.changedTouches || event.changedTouches.length !== 1) return;
          var deltaX = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(deltaX) < 54) return;
          activateMediaByIndex(activeMediaIndex + (deltaX < 0 ? 1 : -1));
        }, { passive: true });
      }

      // Lightbox
      if (zoomButton && lightbox && lightboxImage) {
        zoomButton.addEventListener('click', function () {
          var activePanel = panels[activeMediaIndex];
          var image = activePanel ? activePanel.querySelector('img') : null;
          if (!image) return;
          lightboxImage.src = image.currentSrc || image.src;
          lightboxImage.alt = image.alt || '';
          lightbox.hidden = false;
          document.body.classList.add('bb-lightbox-open');
        });
      }

      if (lightbox && lightboxClose) {
        lightboxClose.addEventListener('click', function () {
          lightbox.hidden = true;
          document.body.classList.remove('bb-lightbox-open');
        });
        lightbox.addEventListener('click', function (event) {
          if (event.target === lightbox) {
            lightbox.hidden = true;
            document.body.classList.remove('bb-lightbox-open');
          }
        });
      }

      // Sticky ATC visibility
      if (sticky) {
        function updateStickyVisibility() {
          var anchor = productPage.querySelector('.bb-product-buy-card');
          if (!anchor) return;
          var shouldShow = anchor.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle('is-visible', shouldShow);
          sticky.setAttribute('aria-hidden', String(!shouldShow));
        }
        window.addEventListener('scroll', updateStickyVisibility, { passive: true });
        window.addEventListener('resize', updateStickyVisibility);
        updateStickyVisibility();
      }

      // Initialize option pickers (replaces select dropdown)
      initOptionPickers(productPage, variants);

      productPage.addEventListener('bio-beast:variant-sync', syncVariantState);

      // Init: activate correct media, read availability from Liquid — never override it with JS
      (function () {
        var initStateNode = getSelectedStateNode();
        var initId = initStateNode
          ? (initStateNode.dataset.variantId || (mainForm ? (mainForm.querySelector('[name="id"]') || {}).value : '') || '')
          : '';
        var initVariant = findVariantById(initId);
        if (initVariant && initVariant.featured_media && initVariant.featured_media.id) {
          activateMediaById(String(initVariant.featured_media.id));
        } else {
          activateMediaByIndex(activeMediaIndex);
        }
        // Sync button/qty from Liquid's stateNode — don't call syncStateDataToForm, which overwrites availability
        forms.forEach(function (f) { syncProductFormState(f); });
      }());
    });
  }

  /* ── Cart drawer ── */

  var cartDrawerEl = null;
  var cartDrawerBody = null;
  var cartDrawerFoot = null;
  var cartDrawerBadge = null;
  var cartDrawerOpen = false;

  function openCartDrawer() {
    if (!cartDrawerEl) return;
    cartDrawerEl.setAttribute('aria-hidden', 'false');
    cartDrawerEl.classList.add('is-open');
    document.body.classList.add('bb-cart-open');
    cartDrawerOpen = true;
    var panel = cartDrawerEl.querySelector('.bb-cart-drawer__panel');
    if (panel) window.setTimeout(function () { panel.focus(); }, 60);
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawerEl) return;
    cartDrawerEl.setAttribute('aria-hidden', 'true');
    cartDrawerEl.classList.remove('is-open');
    document.body.classList.remove('bb-cart-open');
    cartDrawerOpen = false;
  }

  function buildCartItemHTML(item) {
    var linePrice = formatMoney(item.final_line_price);
    var imgTag = item.image
      ? '<img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" width="64" height="64" loading="lazy">'
      : '';
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<span class="bb-cart-item__variant">' + item.variant_title + '</span>'
      : '';

    return '<div class="bb-cart-item" data-cart-key="' + item.key + '">' +
      '<a class="bb-cart-item__img" href="' + item.url + '" tabindex="-1">' + imgTag + '</a>' +
      '<div class="bb-cart-item__info">' +
        '<a class="bb-cart-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
        variantLine +
        '<div class="bb-cart-item__row">' +
          '<div class="bb-cart-qty" data-cart-qty="' + item.key + '">' +
            '<button type="button" class="bb-cart-qty__btn" data-cart-qty-change="' + item.key + '" data-delta="-1" aria-label="Decrease quantity">−</button>' +
            '<span class="bb-cart-qty__val">' + item.quantity + '</span>' +
            '<button type="button" class="bb-cart-qty__btn" data-cart-qty-change="' + item.key + '" data-delta="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<span class="bb-cart-item__price">' + linePrice + '</span>' +
          '<button type="button" class="bb-cart-item__remove" data-cart-remove="' + item.key + '" aria-label="Remove item">' +
            '<svg class="bb-svg-icon" viewBox="0 0 24 24" fill="none"><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  async function refreshCartDrawer() {
    try {
      var response = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      var cart = await response.json();

      updateCartCount(cart.item_count || 0);
      if (cartDrawerBadge) cartDrawerBadge.textContent = cart.item_count || 0;

      if (cartDrawerBody) {
        if (cart.item_count > 0) {
          cartDrawerBody.innerHTML = cart.items.map(buildCartItemHTML).join('');
        } else {
          cartDrawerBody.innerHTML =
            '<div class="bb-cart-drawer__empty">' +
              '<div class="bb-cart-drawer__empty-icon"><svg class="bb-svg-icon" viewBox="0 0 24 24" fill="none"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4ZM3 6h18M16 10a4 4 0 0 1-8 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
              '<p class="bb-cart-drawer__empty-title">Your cart is empty</p>' +
              '<p class="bb-cart-drawer__empty-text">Add some science to your life.</p>' +
              '<a href="/collections/all" class="bb-button bb-button--primary">Browse products</a>' +
            '</div>';
        }
      }

      if (cartDrawerFoot) {
        if (cart.item_count > 0) {
          cartDrawerFoot.innerHTML =
            '<div class="bb-cart-drawer__subtotal">' +
              '<span>Subtotal</span>' +
              '<span class="bb-cart-drawer__subtotal-price">' + formatMoney(cart.total_price) + '</span>' +
            '</div>' +
            '<p class="bb-cart-drawer__tax-note">Taxes and shipping calculated at checkout.</p>' +
            '<a class="bb-button bb-button--primary bb-cart-drawer__checkout" href="/checkout">Checkout</a>' +
            '<a class="bb-cart-drawer__view-cart" href="/cart">View cart</a>';
        } else {
          cartDrawerFoot.innerHTML = '';
        }
      }
    } catch (e) {
      // silently fail
    }
  }

  async function cartChange(key, quantity) {
    try {
      var response = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      if (!response.ok) return;
      var cart = await response.json();
      updateCartCount(cart.item_count || 0);
      await refreshCartDrawer();
    } catch (e) {
      // silently fail
    }
  }

  function initCartDrawer() {
    cartDrawerEl = document.querySelector('[data-cart-drawer]');
    if (!cartDrawerEl) return;

    cartDrawerBody = cartDrawerEl.querySelector('[data-cart-drawer-body]');
    cartDrawerFoot = cartDrawerEl.querySelector('[data-cart-foot]');
    cartDrawerBadge = cartDrawerEl.querySelector('[data-cart-drawer-count]');

    // Open triggers
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', openCartDrawer);
    });

    // Close triggers
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeCartDrawer);
    });

    // Escape key
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && cartDrawerOpen) closeCartDrawer();
    });

    // Cart item interactions (qty + remove) — delegated
    cartDrawerEl.addEventListener('click', async function (event) {
      var qtyBtn = event.target.closest('[data-cart-qty-change]');
      if (qtyBtn) {
        event.preventDefault();
        var key = qtyBtn.dataset.cartQtyChange;
        var delta = parseInt(qtyBtn.dataset.delta || '0', 10);
        var qtyEl = cartDrawerEl.querySelector('[data-cart-qty="' + key + '"] .bb-cart-qty__val');
        var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        var newQty = Math.max(0, currentQty + delta);
        await cartChange(key, newQty);
        return;
      }

      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        await cartChange(removeBtn.dataset.cartRemove, 0);
      }
    });

    // Listen for cart updates from add-to-cart
    document.addEventListener('bio-beast:cart:updated', function () {
      if (!cartDrawerOpen) openCartDrawer();
      else refreshCartDrawer();
    });
  }

  /* ── Cart Page ── */

  function initCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    var wrap = page.querySelector('[data-cart-page-wrap]');
    if (!wrap) return; // empty cart — nothing to wire up

    var busy = false;

    function qs(sel) { return page.querySelector(sel); }
    function itemEl(key) { return page.querySelector('[data-item-key="' + key + '"]'); }
    function pluralItems(n) { return n + (n === 1 ? ' item' : ' items'); }

    function setLoading(key, on) {
      var el = itemEl(key);
      if (el) el.classList.toggle('is-loading', on);
    }

    function showItemError(key, msg) {
      var errEl = qs('[data-cart-item-error="' + key + '"]');
      if (errEl) { errEl.textContent = msg; errEl.classList.remove('is-hidden'); }
    }

    function clearItemError(key) {
      var errEl = qs('[data-cart-item-error="' + key + '"]');
      if (errEl) { errEl.textContent = ''; errEl.classList.add('is-hidden'); }
    }

    function updateCheckoutState() {
      var hasOos = Array.from(page.querySelectorAll('[data-item-key]')).some(function (el) {
        return el.classList.contains('is-unavailable');
      });
      var btn = qs('[data-cart-checkout]');
      var warn = qs('[data-cart-checkout-warning]');
      if (btn) {
        btn.classList.toggle('is-disabled', hasOos);
        btn.setAttribute('aria-disabled', String(hasOos));
        if (hasOos) btn.setAttribute('tabindex', '-1');
        else btn.removeAttribute('tabindex');
      }
      if (warn) warn.classList.toggle('is-hidden', !hasOos);
    }

    function showEmptyState() {
      wrap.innerHTML =
        '<div class="bb-cart-empty-state">' +
          '<div class="bb-cart-empty-state__icon">' +
            '<svg class="bb-svg-icon" viewBox="0 0 24 24" fill="none">' +
              '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4ZM3 6h18M16 10a4 4 0 0 1-8 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</div>' +
          '<h2 class="bb-cart-empty-state__title">Your cart is empty</h2>' +
          '<p class="bb-cart-empty-state__text">Looks like you haven\'t added anything yet.</p>' +
          '<a href="/collections/all" class="bb-button bb-button--primary">Start shopping</a>' +
        '</div>';
    }

    function applyCartData(cart) {
      updateCartCount(cart.item_count || 0);

      var countEl = qs('[data-cart-page-count]');
      if (countEl) countEl.textContent = pluralItems(cart.item_count);

      if (cart.item_count === 0) { showEmptyState(); return; }

      // Update existing items
      cart.items.forEach(function (item) {
        var el = itemEl(item.key);
        if (!el) return;
        el.classList.remove('is-loading');
        clearItemError(item.key);

        var qtyInput = el.querySelector('[data-cart-page-qty-input]');
        if (qtyInput) qtyInput.value = String(item.quantity);

        var linePrice = el.querySelector('[data-cart-page-line-price]');
        if (linePrice) linePrice.textContent = formatMoney(item.final_line_price);

        var summQty = qs('[data-cart-page-summary-qty="' + item.key + '"]');
        if (summQty) summQty.textContent = String(item.quantity);

        var summPrice = qs('[data-cart-page-summary-price="' + item.key + '"]');
        if (summPrice) summPrice.textContent = formatMoney(item.final_line_price);
      });

      // Remove DOM rows for items no longer in cart
      Array.from(page.querySelectorAll('[data-item-key]')).forEach(function (el) {
        var k = el.dataset.itemKey;
        if (!cart.items.some(function (i) { return i.key === k; })) {
          var sl = qs('[data-cart-page-summary-line="' + k + '"]');
          if (sl) sl.remove();
          el.classList.add('is-removing');
          window.setTimeout(function () { el.remove(); updateCheckoutState(); }, 250);
        }
      });

      var subtotalEl = qs('[data-cart-page-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      updateCheckoutState();
    }

    async function cartUpdate(key, qty) {
      if (busy) return;
      busy = true;
      setLoading(key, true);

      try {
        var resp = await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        var data = await resp.json();

        if (!resp.ok) {
          setLoading(key, false);
          showItemError(key, data.description || data.message || 'Could not update item.');
          // Reset qty input to actual cart value
          var cartResp = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
          if (cartResp.ok) {
            var cart = await cartResp.json();
            var realItem = cart.items.find(function (i) { return i.key === key; });
            if (realItem) {
              var inp = page.querySelector('[data-cart-page-qty-input="' + key + '"]');
              if (inp) inp.value = String(realItem.quantity);
            }
          }
        } else {
          applyCartData(data);
        }
      } catch (e) {
        setLoading(key, false);
      }

      busy = false;
    }

    // Intercept disabled checkout link
    page.addEventListener('click', function (e) {
      var checkoutLink = e.target.closest('[data-cart-checkout]');
      if (checkoutLink && checkoutLink.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        return;
      }

      var minus = e.target.closest('[data-cart-page-qty-minus]');
      if (minus) {
        var k = minus.dataset.cartPageQtyMinus;
        var inp = page.querySelector('[data-cart-page-qty-input="' + k + '"]');
        var cur = inp ? parseInt(inp.value, 10) : 1;
        if (cur > 1) cartUpdate(k, cur - 1);
        return;
      }

      var plus = e.target.closest('[data-cart-page-qty-plus]');
      if (plus) {
        var k2 = plus.dataset.cartPageQtyPlus;
        var inp2 = page.querySelector('[data-cart-page-qty-input="' + k2 + '"]');
        var cur2 = inp2 ? parseInt(inp2.value, 10) : 1;
        cartUpdate(k2, cur2 + 1);
        return;
      }

      var rem = e.target.closest('[data-cart-page-remove]');
      if (rem) {
        cartUpdate(rem.dataset.cartPageRemove, 0);
      }
    });

    // Manual qty input
    page.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-page-qty-input]')) return;
      var k = e.target.dataset.cartPageQtyInput;
      var v = parseInt(e.target.value, 10);
      if (!Number.isNaN(v) && v >= 0) cartUpdate(k, v);
    });

    // Cart note auto-save
    var noteEl = qs('[data-cart-note]');
    if (noteEl) {
      var noteTimer;
      noteEl.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = window.setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteEl.value })
          });
        }, 600);
      });
    }
  }

  /* ── Product recommendations ── */

  function initProductRecommendations() {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
      var url = section.dataset.url;
      var inner = section.querySelector('[data-product-recommendations-inner]');
      if (!url || !inner || inner.children.length > 0) return;

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load recommendations.');
          return response.text();
        })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var recommendations = html.querySelector('[data-product-recommendations-inner]');
          if (recommendations && recommendations.children.length > 0) {
            inner.innerHTML = recommendations.innerHTML;
            section.classList.remove('is-empty');
          }
        })
        .catch(function () {
          section.classList.add('is-empty');
        });
    });
  }

  /* ── Init ── */

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initSearchModal();
    initQuickAdd();
    initProductForms();
    initProductPage();
    initCartPage();
    initCartDrawer();
    initProductRecommendations();
  });

})();
